import React, { useEffect, useState } from "react";

const Countdown = ({ targetDate }) => {
	const calculateTimeLeft = () => {
		const now = new Date();
		const target = new Date(targetDate); // parse the timestamptz string into a Date object
		const difference = target - now;
		let timeLeft = {};

		if (difference > 0) {
			timeLeft = {
				days: Math.floor(difference / (1000 * 60 * 60 * 24)),
				hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
				minutes: Math.floor((difference / (1000 * 60)) % 60),
				seconds: Math.floor((difference / 1000) % 60),
			};
		}

		return timeLeft;
	};

	const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

	useEffect(() => {
		const timer = setInterval(() => {
			setTimeLeft(calculateTimeLeft());
		}, 1000);

		return () => clearInterval(timer);
	}, [targetDate]);

	return (
		<div className="flex flex-col items-center w-full h-full mt-16 min-w-80 max-w-80 sm:min-w-96 sm:max-w-96 bg-white p-6 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] ">
			<h1 className="text-2xl text-gray-600 font-bold text-center mb-8">
				Le quiz sera disponible dans:
			</h1>
			<div className="font-orbitron text-3xl font-bold text-[#fbb554] my-3">
				{timeLeft.days > 0 && <span>{timeLeft.days}j </span>}
				<span>{String(timeLeft.hours).padStart(2, "0")}h </span>
				<span>{String(timeLeft.minutes).padStart(2, "0")}m </span>
				<span>{String(timeLeft.seconds).padStart(2, "0")}s</span>
			</div>
			<p className="text-gray-600 my-3">
				Revenez plus tard pour commencer le quiz.
			</p>
		</div>
	);
};

export default Countdown;
